import { Box, Card, DialogTitle, IconButton, Stack, TextField, Typography, Grid, CircularProgress, Badge } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from "react-redux";
import MDButton from "components/MDButton";
import { redirect, useNavigate } from "react-router-dom";
import defaultImage from 'assets/images/placeholder-image.png';
import { useEffect, useState } from "react";
import MDInput from "components/MDInput";
import { uploadImage } from "../../redux/slices/common";
// import { descriptors } from "chart.js/dist/core/core.defaults";

const uploadThumbnailImage = {
    borderRadius: '20px',
    width: '160px',
    height: '160px',
    objectFit: 'cover',
    boxShadow: '0 0 1px rgb(0 0 0 / 20%)'
};
const badgeCircularProgressIcon = {
    backgroundColor: '#fff',
    borderRadius: 10,
    p: .5,
    mr: 14,
    mt: 14
};
export default function AddGridBanner({ closeModal }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { modalData } = useSelector((state) => state.modal);
    const { type, handleSave: onSave, index, dimensions, arrayIndex } = modalData;
    const [isUploading, setIsUploading] = useState(false);
    const [error, setError] = useState({});

    const [formData, setFormData] = useState({
        title: "",
        imageUrl: "",
        index: index,
        altText: "",
        redirectUrl: "",
        description: "",
        type: type,
        arrayIndex: arrayIndex,
        categorybanner: modalData?.categorybanner
    })
    const validURL = (url) => {
        const urlPattern = new RegExp(
            "^(https?:\\/\\/)?" + // protocol
            "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,})" + // domain name
            "(\\:\\d+)?" + // port
            "(\\/[-a-z\\d%@_.~+&:]*)*" + // path
            "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
            "(\\#[-a-z\\d_]*)?$", // fragment
            "i"
        );
        return !!urlPattern.test(url);
    };
    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        // setFormData((prev) => ({
        //     ...prev,
        //     title: selectedFile?.name || ''
        // }))
        if (selectedFile) {
            const fileType = selectedFile.type.split("/")[0];

            if (fileType === "image") {
                setIsUploading(true);

                const body = new FormData();
                body.append("filePath", selectedFile);

                dispatch(uploadImage(body))
                    .unwrap()
                    .then((res) => {
                        setFormData((prev) => ({
                            ...prev,
                            imageUrl: res.fileUrl
                        }))

                        setIsUploading(false);
                    })
                    .catch((err) => {
                        setIsUploading(false);
                    });
            } else {
                alert("Please upload an image or a video file.");
            }
        }
    };


    // const validate = () => {
    //     const temp = {};
    //     if (formData?.altText === '') {
    //         temp.altText = 'Alt Text is required'

    //     }
    //     if (formData?.title === '') {
    //         temp.title = 'Image title is required'
    //     }
    //     if (formData?.redirectUrl === '') {
    //         temp.redirectUrl = 'Url is required'
    //     }
    //     else if (!validURL(formData?.redirectUrl)) {
    //         temp.redirectUrl = 'Please enter a valid url'
    //     }

    //     if (!formData?.description?.trim()) {
    //         temp.description = "Description is required";
    //     }


    //     setError(temp);

    //     // Return true if no errors
    //     return Object.keys(temp).length === 0;
    // };
    const validate = () => {
        const temp = {};

        if (!formData?.altText?.trim()) {
            temp.altText = "Alt Text is required";
        }

        if (!formData?.title?.trim()) {
            temp.title = "Image title is required";
        }

        if (!formData?.redirectUrl?.trim()) {
            temp.redirectUrl = "Destination URL is required";
        } else if (!validURL(formData.redirectUrl.trim())) {
            temp.redirectUrl = "Enter a valid URL";
        }

        if (!formData?.description?.trim()) {
            temp.description = "Description is required";
        }

        setError(temp);
        return Object.keys(temp).length === 0;
    };

    const onHandleSave = () => {
        if (!validate()) return;
        setError({});
        onSave(formData)
        closeModal();
    }

    
    useEffect(() => {
        if (modalData?.categoryData) {
          setFormData((prev) => ({
            ...prev,
            ...modalData.categoryData,
          }));
        }
      }, [modalData?.categoryData]);

    return (
        <Card sx={{ py: 3, px: 4, borderRadius: 0 }}>
            <DialogTitle id='draggable-dialog-title' sx={{ p: 0, mb: 4 }} display='flex' alignItems='center' justifyContent='space-between'>
                <Box display="flex" alignItems="center" gap={2}>
                    Add Bento Grid
                </Box>
                <IconButton onClick={closeModal} edge='end' size='small' className='modal-close'>
                    <CloseIcon fontSize='medium' />
                </IconButton>
            </DialogTitle>
            <div style={{ paddingLeft: "0", paddingRight: "0" }}>
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={12}>
                        <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} mb={4.5}>
                            <Badge
                                overlap='circular'
                                anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                                badgeContent={
                                    isUploading ? <CircularProgress size={32} color='primary' sx={badgeCircularProgressIcon} /> : ''
                                }
                            >
                                <img style={uploadThumbnailImage} src={formData?.imageUrl || defaultImage} alt='' />

                            </Badge>

                            <label htmlFor='image-input'>
                                <MDButton
                                    sx={{ minWidth: '180px' }}
                                    type='button'
                                    variant='outlined'
                                    color='secondary'
                                    component='span'
                                    disabled={isUploading}
                                >
                                    {
                                        formData?.imageUrl ? 'Update Image' : 'Add Image'
                                    }
                                    &nbsp; {dimensions}
                                </MDButton>
                            </label>

                            <MDInput
                                id='image-input'
                                type='file'
                                name='image'
                                onChange={handleFileChange}
                                fullWidth
                                disabled={isUploading}
                                style={{ display: 'none' }}
                            />
                        </Stack>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant='body2' fontWeight="medium" color="#9A9AAF" mb={1} style={{ fontSize: "14px" }}>Image Title</Typography>
                        <TextField
                            label=""
                            className="form-input fs-14"
                            fullWidth
                            placeholder=""
                            error={!!error.title}
                            helperText={error.title}
                            value={formData?.title}
                            onChange={(e) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    title: e.target.value
                                }))
                                setError((prev) => ({ ...prev, title: "" }))
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant='body2' fontWeight="medium" color="#9A9AAF" mb={1} style={{ fontSize: "14px" }}>Alt Text</Typography>
                        <TextField
                            label=""
                            className="form-input fs-14"
                            fullWidth
                            placeholder=""
                            error={!!error.altText}
                            helperText={error.altText}
                            value={formData?.altText}
                            onChange={(e) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    altText: e.target.value
                                }))

                                setError((prev) => ({ ...prev, altText: "" }));
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Typography variant='body2' fontWeight="medium" color="#9A9AAF" mb={1} style={{ fontSize: "14px" }}>Destination URL</Typography>
                        <TextField
                            label=""
                            className="form-input fs-14"
                            fullWidth
                            placeholder=""
                            value={formData?.redirectUrl}
                            error={!!error.redirectUrl}
                            helperText={error.redirectUrl}
                            onChange={(e) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    redirectUrl: e.target.value
                                }))
                                setError((prev) => ({ ...prev, redirectUrl: "" }))
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Typography variant='body2' fontWeight="medium" color="#9A9AAF" mb={1} style={{ fontSize: "14px" }}>Description</Typography>
                        <TextField
                            label=""
                            className="form-input fs-14"
                            fullWidth
                            placeholder=""
                            error={!!error.description}
                            helperText={error.description}
                            value={formData?.description}
                            onChange={(e) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    description: e.target.value
                                }))
                                setError((prev) => ({ ...prev, description: "" }))
                            }}
                        />
                    </Grid>
                </Grid>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} mt={4} mb={1}>
                    <MDButton onClick={onHandleSave} sx={{ width: '150px' }} type='button' variant='contained' color='primary' disabled={!formData?.imageUrl}>
                        Add
                    </MDButton>
                    <MDButton sx={{ width: '150px' }} type='button' variant='outlined' color='dark' onClick={closeModal}>
                        Cancel
                    </MDButton>
                </Stack>
            </div>
        </Card>
    )
}